import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 20,
	viewBox: "0 0 26 18",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: 2,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m1 1h24" }),
		/* @__PURE__ */ _jsx("path", { d: "m1 9.231h24" }),
		/* @__PURE__ */ _jsx("path", { d: "m1 17h24" })
	]
});
export default SvgMenu;
